export default {
  form: {
    title: '【老屋醫生】居家修繕報修單',
    welcome: '親愛的顧客，感謝您選擇我們的服務。請填寫資料，以便我們了解您的需求，並提供最佳的修繕服務。 謝謝',
    email: 'Email',
    emailPlaceholder: '您的電子郵件',
    name: '姓名',
    namePlaceholder: '您的回答',
    phone: '電話',
    phonePlaceholder: '您的回答',
    address: '地址',
    addressPlaceholder: '您的回答',
    lineId: 'Line ID',
    lineIdHint: '立案後會以LINE ID，加為點數聯絡人，個人資料 > ID',
    lineIdPlaceholder: '您的回答',
    isUrgent: '是否為緊急情況',
    urgentGeneral: '一般場勘 $300~800',
    urgentEmergency: '緊急場勘 $1200~1500',
    repairType: '修繕類型',
    noRepairItems: '暫無修繕項目',
    repairTypes: {
      water: '水類',
      electric: '電類',
      leak: '漏水',
      comprehensive: '綜合',
      equipment: '衛浴設備',
      other: '其他'
    },
    description: '補充說明',
    descriptionPlaceholder: '您的回答',
    images: '圖片/視頻上傳，拍攝方式的圖片或視頻等資訊',
    howKnow: '如何得知老屋醫生',
    howKnowOptions: {
      fate: '緣故',
      referral: '客介',
      line: 'LINE',
      fb: 'FB',
      ad: '廣告',
      other: '其他'
    },
    otherPlaceholder: '請說明',
    referrer: '介紹人姓名、店家',
    referrerPlaceholder: '您的回答',
    joinedLine: '加入【老屋醫生】了嗎？',
    joinedLineHint: '填寫完表單後，別忘了在LINE官方帳號上發佈通知作業人員＂修繕囉＂！',
    lineAccount: '【老屋醫生】LINE官方帳號：',
    yes: '是',
    no: '否',
    submit: '提交',
    clear: '清除表單',
    required: '此欄位為必填',
    invalidEmail: '請輸入有效的電子郵件地址',
    invalidPhone: '請輸入10位數字的電話號碼',
    invalidFileType: '只能上傳圖片或視頻文件',
    imageTooLarge: '圖片大小不能超過10MB',
    videoTooLarge: '視頻大小不能超過100MB',
    submitSuccess: '預約提交成功！我們會盡快與您聯繫。',
    submitFailed: '提交失敗，請稍後再試。',
    uploadSuccess: '文件上傳成功',
    uploadFailed: '文件上傳失敗',
    imagePreview: '圖片預覽',
    videoPreview: '視頻預覽'
  },
  language: {
    zhTW: '繁體中文',
    zhCN: '简体中文'
  },
  navigation: {
    myReservations: '訂單查詢'
  },
  success: {
    title: '恭喜！預約成功',
    message: '您的維修預約已成功提交，我們會盡快與您聯繫。請保持電話暢通。',
    reservationId: '預約編號',
    phone: '聯繫電話',
    createTime: '提交時間',
    viewMyReservations: '查看我的預約',
    backToHome: '返回首頁'
  },
  myReservations: {
    title: '我的預約記錄',
    subtitle: '請輸入您的電話和Email查詢預約記錄',
    searchBy: '查詢方式（電話和Email必填）',
    phonePlaceholder: '請輸入電話號碼',
    emailPlaceholder: '請輸入Email地址',
    enterSearchCriteria: '請輸入電話和Email',
    search: '查詢',
    reservationId: '預約編號',
    createTime: '提交時間',
    viewDetail: '查看詳情',
    noData: '暫無預約記錄',
    backToHome: '返回首頁',
    detailTitle: '預約詳情',
    basicInfo: '基本資訊',
    repairInfo: '維修資訊',
    images: '相關圖片',
    searchFailed: '查詢失敗',
    loadFailed: '載入失敗',
    region: '地區',
    sourceInfo: '來源資訊',
    timeInfo: '時間資訊',
    updateTime: '更新時間',
    status: {
      label: '狀態',
      PENDING_REVIEW: '待審核',
      PENDING: '待分配門店',
      PENDING_TECHNICIAN: '待分配師傅',
      QUOTED: '已報價',
      PENDING_CUSTOMER_CONFIRM: '待客戶確認',
      MATERIAL_PREPARING: '備料中',
      PENDING_CONSTRUCTION: '待施工',
      CONSTRUCTING: '施工中',
      PENDING_ACCEPTANCE: '待驗收',
      ACCEPTANCE: '驗收中',
      COMPLETED: '已完成',
      CLOSED: '已結案',
      CANCELLED: '已取消'
    },
    caseNo: '案例編號',
    quotationStage: '報價資訊',
    materialStage: '備料資訊',
    constructionStage: '施工資訊',
    acceptanceStage: '驗收資訊',
    currentStage: '當前階段',
    quotedAmount: '報價金額',
    quotationDesc: '報價說明',
    quotationTime: '報價時間',
    totalApprovedAmount: '總批准金額',
    materialName: '材料名稱',
    materialPrice: '材料價格',
    prepareTime: '備料時間',
    constructionDate: '施工日期',
    beforeConstruction: '施工前',
    duringConstruction: '施工中',
    afterConstruction: '施工後',
    completionDate: '完成日期',
    chargeAmount: '收費金額',
    paymentMethod: '支付方式',
    collectionAmount: '收款金額',
    customerConfirm: '客戶確認',
    customerSignature: '客戶簽名',
    remark: '備註',
    description: '描述',
    recordTime: '記錄時間',
    pendingConfirmNotice: '師傅已提交報價，請確認是否接受此報價',
    confirmQuotation: '確認報價',
    rejectQuotation: '拒絕報價',
    confirmQuotationMessage: '確認接受此報價後，訂單將進入備料階段，是否繼續？',
    confirm: '確認',
    cancel: '取消',
    confirmReject: '確認拒絕',
    rejectReason: '拒絕原因',
    rejectReasonPlaceholder: '請輸入拒絕報價的原因',
    rejectReasonRequired: '請輸入拒絕原因',
    confirmSuccess: '報價確認成功',
    confirmFailed: '報價確認失敗',
    rejectSuccess: '報價已拒絕，等待師傅重新報價',
    rejectFailed: '拒絕報價失敗',
    reviewSection: '服務評價',
    technicianReview: '師傅對您的評價',
    customerReview: '您對師傅的評價',
    technician: '師傅',
    myReview: '我的評價',
    yourRating: '您的評分',
    yourReview: '您的評價',
    reviewTime: '評價時間',
    noReviewYet: '您尚未對此次服務進行評價',
    writeReview: '撰寫評價',
    rating: '評分',
    reviewContent: '評價內容',
    reviewContentPlaceholder: '請分享您對師傅服務的評價（選填）',
    ratingRequired: '請選擇評分',
    submitReview: '提交評價',
    reviewSuccess: '評價提交成功，感謝您的反饋',
    reviewFailed: '評價提交失敗',
    reviewSubmittedWaiting: '您已提交評價，待師傅評價後即可查看雙方評價內容',
    technicianStats: '師傅評價統計',
    avgRating: '平均評分',
    totalReviews: '累計評價',
    reviewCount: '則',
    ratingTexts: {
      1: '非常不滿意',
      2: '不滿意',
      3: '一般',
      4: '滿意',
      5: '非常滿意'
    }
  }
}
